import React, { useState } from "react";
import { createFolder } from "../services/folderService";
import "./FolderForm.css";
import { useToast } from "../context/ToastContext";
import { extractErrorMessage } from "../utils/errorUtils";

function FolderForm({ parentId, onSuccess }) {
  const [name, setName] = useState("");
  const { addToast } = useToast();

  // useEffect(() => {
  //   console.log("🪵 FolderForm received parentId:", parentId);
  // }, [parentId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await createFolder({
        name,
        parentId,
      });
      addToast("Folder created successfully!", "success");
      setName("");
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error(err);
      const errorMessage = await extractErrorMessage(err, "Error creating folder.");
      addToast(errorMessage, "error");
    }
  };

  return (
    <form className="folder-form" onSubmit={handleSubmit}>
      <div className="form-row">
        <input
          type="text"
          placeholder="Folder name"
          className="input"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
        <button type="submit" className="btn-primary">
          ➕ Create Folder
        </button>
      </div>
    </form>
  );
}

export default FolderForm;
